import React, {useContext, useState} from 'react';
import {Formik} from "formik";
import {BootstrapError, BootstrapField} from "../../../helpers/Field";
import * as yup from 'yup';
import {InvoicesContext} from "../../invoice/InvoiceDataManager";
import {validateAccount} from "../../../requests/UserRequests";

const schema = yup.object().shape({
    invoiceNumber: yup.string().required("Invoice number is required."),
    invoiceAmount: yup.number().typeError("Invoice amount is required. Numeric values only.").required("Invoice amount is required. Numeric values only."),
    accountNumber: yup.string().required("Account number is required."),
});

function AutoLinkAccountForm(props) {
    let [requestComplete, setRequestComplete] = useState(false);
    const invoicesContext = useContext(InvoicesContext);

    return (
        <div>
            {!requestComplete && <Formik
              initialValues={{}}
              validationSchema={schema}
              onSubmit={(formProps, bag) => {
                  validateAccount(formProps).then(response => {
                      props.onSuccess(response.invoice);
                  }).catch((error) => {
                      if (error.response.status === 404) {
                          props.onError("We could not find an account from the given details.")
                      } else {
                          if (error.response.data.key === "duplicate") {
                              props.onError("You've already added this account.")
                          } else {
                              props.onError("Too many failed attempts. Try again later.")
                          }
                      }
                  });
              }}
              render={formProps =>
                  <div className="card">
                      <p>To setup an account you will need an invoice number, invoice amount, and your account
                          number.</p>
                      <form onSubmit={formProps.handleSubmit}>
                          <div className="row">
                              <div className={"col-12"}>
                                  <div className="form-group">
                                      <label>Account Number </label>
                                      <BootstrapField type={"text"} name={"accountNumber"}/>
                                      <BootstrapError name={"accountNumber"}/>
                                  </div>
                                  <div className="form-group">
                                      <label>Invoice Number</label>
                                      <BootstrapField type={"text"} name={"invoiceNumber"}/>
                                      <BootstrapError name={"invoiceNumber"}/>
                                  </div>
                                  <div className="form-group">
                                      <label>Invoice Amount</label>
                                      <BootstrapField type={"text"} name={"invoiceAmount"}/>
                                      <BootstrapError name={"invoiceAmount"}/>
                                  </div>
                                  <div className={"form-group"}>
                                      <button type={"submit"} className={"btn btn-primary"}>Add Account</button>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>
              }/>}
            {requestComplete && <React.Fragment>
              <div className="card">
                <div>
                  Thanks for submitting a registration request. We will get back with your shortly.
                </div>
              </div>

            </React.Fragment>
            }
        </div>
    );
}

export default AutoLinkAccountForm;
